import { assert } from '../app/logger.js';
import { window } from '../window.js';
import { ChecklistViewBase } from './checklist_view_base.js';

/**
 * Serves to get/set data from a checklist editor.
 */
class ChecklistViewPack extends ChecklistViewBase {
  async sync() {
    let promise = super.sync();
    if (promise) {
      await promise;
      // Update UI according checked/unchecked statuses manually, because
      // checklist.load() doesn't trigger UI update if states were changed only
      // (no name change).
      this.#updateView(this.getDataFromUI(), this.checklist.packItems);
    }
  }

  async #onItemChecked(itemEl, dataItem) {
    function itemCheckedReq(inputEl, dataItem) {
      let itemEl = inputEl.parentNode.parentNode;
      let data = [
        {
          id: dataItem.id,
          checked: inputEl.checked,
        },
      ];
      dataItem.checked = inputEl.checked;

      if (itemEl.parentNode.parentNode.localName != 'checklist-view-pack') {
        let hasUncheckedSibling = !!itemEl.parentNode.querySelector(
          'input:not(:checked)'
        );

        let parentItem = itemEl.parentNode.previousElementSibling;
        let parentInput = parentItem.querySelector('input');
        let isParentChecked = parentInput.checked;

        if (hasUncheckedSibling) {
          if (isParentChecked) {
            parentInput.checked = false;
            Array.prototype.push.apply(
              data,
              itemCheckedReq(parentInput, dataItem.parent)
            );
          }
        } else if (!isParentChecked) {
          parentInput.checked = true;
          Array.prototype.push.apply(
            data,
            itemCheckedReq(parentInput, dataItem.parent)
          );
        }
      }
      return data;
    }

    await this.checklist.packGear(itemCheckedReq(event.target, dataItem));
    this.checklistChanged();
  }

  #updateView(uiItem, dataItem) {
    let uiChildren = uiItem.children;
    let dataChildren = dataItem.children;
    assert(
      uiChildren.length == dataChildren.length,
      'UI and data out of sync!'
    );

    for (let idx = 0; idx < dataChildren.length; idx++) {
      let childDataItem = dataChildren[idx];
      let childUIItem = uiChildren[idx];
      assert(
        childUIItem.name == childDataItem.name,
        `UI and data out of sync!`
      );
      this.setItem(childUIItem.el, childDataItem);
      this.#updateView(childUIItem, childDataItem);
    }
  }

  // Protected
  pipeToData(refreshFunc) {
    this.pipe = this.checklist.pipeables.packItems.pipe(refreshFunc);
  }

  setItem(itemEl, dataItem) {
    let checked = dataItem.checked == '1' ? 'checked' : '';
    itemEl.innerHTML = `<label><input type='checkbox' ${checked}><span>${dataItem.name}</span></label>`;
    itemEl
      .querySelector('input')
      .addEventListener(
        'click',
        ev => this.#onItemChecked(ev.target, dataItem),
        false
      );
  }

  static uiname = 'ChecklistViewPack';
}

window.customElements.define('checklist-view-pack', ChecklistViewPack);

export { ChecklistViewPack };
